// == Appstle Bundle Dynamic Subtext Script ==

// 1. Define the subtext for each bundle title
// IMPORTANT: The keys in this object MUST exactly match the bundle titles displayed on your page.
const bundleSubtexts = {
    "PACK OF 3 + GET 3 EXTRA FREE": "<b>✔</b> The best value pack. <br> <b>✔</b> Perfect for stocking up.",
    "PACK OF 2 + GET 2 EXTRA FREE": "<b>✔</b> Enjoy great savings.",
    "PACK OF 1 + GET 1 EXTRA FREE": "<b>✔</b> Perfect to try out 3ryv Enzymes.",
    // Add more bundles here if needed
};

// 2. Function to inject the subtext container into each bundle item
function injectSubtextContainers() {
    // Target all Appstle bundle containers
    const bundleItems = document.querySelectorAll('.ab-volume-discount-item-container');

    bundleItems.forEach(item => {
        // Check if the subtext has already been injected to prevent duplicates
        if (item.querySelector('.custom-bundle-subtext')) {
            return;
        }

        // Get the bundle title and the container where we want to inject the subtext
        const titleElement = item.querySelector('.ab-volume-discount-item-title-label');
        const informationContainer = item.querySelector('.ab-volume-discount-item-information-container');

        if (titleElement && informationContainer) {
            const title = titleElement.textContent.trim();
            const subtext = bundleSubtexts[title];

            if (subtext) {
                // Create the new subtext element
                const subtextElement = document.createElement('div');
                subtextElement.className = 'custom-bundle-subtext';
                subtextElement.innerHTML = subtext;

                // Insert the subtext element right after the existing subtitle
                const subtitleElement = item.querySelector('.ab-volume-discount-item-save-subtitle-label');
                if (subtitleElement) {
                    subtitleElement.insertAdjacentElement('afterend', subtextElement);
                } else {
                    // Fallback: append to the information container
                    informationContainer.appendChild(subtextElement);
                }
            }
        }
    });
}

// 3. Use a MutationObserver to ensure the script runs after Appstle's bundles are loaded
// Appstle bundles are often loaded dynamically, so we need to wait for them.
const targetNode = document.body;
const config = { childList: true, subtree: true };

const observer = new MutationObserver((mutationsList, observer) => {
    // Check if the main Appstle container is present
    const appstleContainer = document.querySelector('.ab-volume-discount-rule-content');
    if (appstleContainer) {
        // Process the elements
        injectSubtextContainers();
        // We can disconnect the observer once the bundles are loaded
        observer.disconnect(); 
    }
});

// Start observing the document body for changes
observer.observe(targetNode, config);

// Also run once on DOMContentLoaded for cases where the bundles load quickly
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSubtextContainers);
} else {
    injectSubtextContainers();
}
